import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";
import FilterBox from "@/components/FilterBox/FilterBox.vue";
import WordService from "@/services/WordService";
import { isSmallDevice } from "@/common/functions";
import OneTrustService from "@/services/OneTrustService";

export default {
    components: {
        LayoutStatic,
        BrowsePanel: () =>
            import(
                /* webpackChunkName: "browsePanel" */ "@/components/BrowseByIndexPanel/BrowsePanel/BrowsePanel.vue"
            ),
        FilterBox,
        SimpleDotLoader: () =>
            import(
                /* webpackChunkName: "simpleDotLoader" */ "@/components/SimpleDotLoader/SimpleDotLoader.vue"
            )
    },
    data() {
        return {
            layout: LayoutStatic,
            letter: this.$route.params.index || "",
            defaultWordsList: [],
            filteredWordsList: [],
            filterValue: "",
            isProcessing: false,
            isSmallDevice
        };
    },
    computed: {
        indexKey() {
            return this.letter.toUpperCase();
        }
    },
    watch: {
        $route() {
            this.letter = this.$route.params.index || "";
            this.getWordsByIndex(22000, this.letter);
        },
        filterValue() {
            this.filterSentenceExamples(this.filterValue);
        }
    },
    metaInfo() {
        return {
            title: this.$t(`sentenceIndexPageMetaTitle`, {
                indexKey: this.indexKey
            }),
            meta: [
                {
                    name: "description",
                    content: this.$t(`sentenceIndexPageMetaDescription`, {
                        indexKey: this.indexKey
                    })
                },
                {
                    name: "keywords",
                    content: this.$t(`sentenceIndexPageMetaKeywords`)
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `https://sentence.yourdictionary.com/index/${this.indexKey.toLowerCase()}`
                }
            ]
        };
    },
    created() {
        this.$emit("update:layout", LayoutStatic);
        this.getWordsByIndex(22000, this.letter);

        this.$root.$on("filterSentenceExamples", value => {
            this.filterValue = value;
        });
    },
    methods: {
        getWordsByIndex(quantity = 300, letter = "") {
            if (!this.isProcessing) {
                this.defaultWordsList = [];
                this.filteredWordsList = [];
                this.isProcessing = true;

                WordService.getWordIndex(quantity, letter)
                    .then(response => {
                        this.defaultWordsList = response.data.data;
                        this.filteredWordsList = response.data.data;
                        this.filterSentenceExamples(this.filterValue);
                        this.isProcessing = false;
                    })
                    .catch(e => {
                        this.isProcessing = false;
                        console.log("e", e);
                    });
            }
        },
        filterSentenceExamples(value) {
            this.filteredWordsList = this.defaultWordsList.filter(word => {
                return word.word.indexOf(value) >= 0;
            });
        }
    },
    mounted() {
        if (typeof window.__PRERENDER_INJECTED === "undefined") {
            // Run only on client side
            OneTrustService.setListeners(this);
            permutive.addon("web", {
                page: {
                    data: {
                        slug: this.$route.path,
                        title: this.$metaInfo.title,
                        type: "search_results",
                        section: "Sentence (V2)",
                        subsection: "Index"
                    }
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/pages/Sentences/Index/SentenceIndex.js